import { toAbsoluteUrl } from '_metronic/helpers'
import { Tooltip } from 'react-tooltip'
import clsx from 'clsx'
// import { isMobileDevice } from '_metronic/assets/ts/_utils'
import { useLang } from '_metronic/i18n/Metronici18n'

interface Props {
	active?: boolean
	nameTh: string
	isColor?: boolean
	hexColor?: string
	featurePicturePath?: string
	nameEn?: string
	tooltip?: string
	imgWidth?: string
	imgHeight?: string
	error?: string
	onClick?: () => void
}

const KumopackProductBox: React.FC<Props> = ({
	active,
	featurePicturePath = '/media/icons/kumopack/default-placeholder-transparent.png',
	nameTh,
	nameEn,
	tooltip,
	onClick,
	error,
}) => {
	const currentLanguage = useLang()

	return (
		<div
			className={clsx(
				'card transition-100 bg-kumopack-grey-50 hover-enabled cursor-pointer w-100 h-200px h-xl-auto',
				{
					'border border-2px border-kumopack-primary-700': active && !error,
					'border border-1px border-kumopack-grey-200': !active && !error,
					'border border-kumopack-error-600': error,
				}
			)}
			onClick={onClick}>
			<div className="card-body p-4 position-relative ">
				<div className="overflow-hidden text-center">
					<img
						className="mx-auto pointer-events-none img-fluid object-fit-cover"
						src={featurePicturePath ?? '/media/icons/kumopack/default-placeholder-transparent.png'}
						alt={`Kumopack Supplier Product - ${nameTh}`}
						onError={(e: any) => {
							e.target.onerror = null
							e.target.src = '/media/icons/kumopack/default-placeholder-transparent.png'
						}}
						style={{ userSelect: 'none', pointerEvents: 'none', height: '160px' }}
					/>
				</div>

				{/* begin:: Tooltip */}
				{tooltip && (
					<span className="position-absolute p-4" style={{ right: 0, top: 0 }}>
						<img
							src={toAbsoluteUrl('/media/icons/kumopack/help-circle.svg')}
							alt="Product Box Tooltip Icon"
							data-tooltip-id={`kumopack-product-box-${tooltip}`}
							data-tooltip-content={tooltip}
							data-tooltip-place="top"
							style={{ userSelect: 'none', pointerEvents: 'none' }}
						/>

						<Tooltip id={`kumopack-product-box-${tooltip}`} place="top" />
					</span>
				)}
				{/* end:: Tooltip */}

				{/* begin:: nameEn */}
				{/* {nameEn && (
					<span
						className="position-absolute text-kumopack-grey-500 fs-6 p-4 text-end"
						style={{ right: -5, bottom: '15%' }}>
						{nameEn}
					</span>
				)} */}
				{/* end:: nameEn */}

				{/* begin:: Title */}
				<span
					className="position-absolute text-kumopack-grey-700 fs-6 py-4 px-2 bottom-0 right-0 text-end"
					style={{ right: 0 }}>
					{currentLanguage === 'en' ? nameEn : nameTh}
				</span>
				{/* end:: Title */}
			</div>
		</div>
	)
}

export default KumopackProductBox
